import createModelStore from "../../utils/createModelStore";
import TaxiService from "../../services/TaxiService";

/** @deprecated */
const taxiServices = createModelStore<TaxiService.Model, "taxiServices">(
	"taxiServices",
);

export default taxiServices;
